import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoshirditempo() {



  const cardData = {


keyword: "Pune to Shirdi Tempo Traveller on Rent",

headingDescription:
    "Ruturaj Enterprises provides comfortable and dependable Pune to Shirdi Tempo Traveller on Rent services for families, devotees, friends, corporate groups, and tour organizers planning Sai Baba Darshan and Shirdi Yatra. Our service includes AC and luxury Tempo Travellers in 13 Seater, 17 Seater, and 20 Seater configurations, making it convenient for both small and larger groups to travel together. We provide one-way and round-trip options with experienced chauffeurs, spacious seating, luggage capacity, convenient pickup from Pune and PCMC areas, and flexible travel schedules. Whether you are planning a Shirdi pilgrimage, family trip, group tour, or dedicated Sai Baba Darshan journey, Ruturaj Enterprises helps make your Pune to Shirdi travel comfortable, organized, and hassle-free.",

topPlaces: [
    {
        title: "Shri Sai Baba Temple",
        description:
            "Shri Sai Baba Temple is the main spiritual attraction in Shirdi and an important pilgrimage destination visited by devotees throughout the year. The temple complex is associated with Sai Baba and attracts families, senior citizens, religious groups, and travelers from across India. A Tempo Traveller is particularly convenient for groups visiting the temple because everyone can travel together, carry their luggage comfortably, and coordinate temple visit timings without arranging multiple vehicles."
    },
    {
        title: "Dwarkamai",
        description:
            "Dwarkamai is one of the most revered places in Shirdi and holds deep spiritual significance for Sai Baba devotees. It is associated with many important events from Sai Baba's life and remains a peaceful place for prayer and reflection. Visitors planning Shirdi Yatra can include Dwarkamai in their itinerary along with other nearby religious attractions, while a spacious Tempo Traveller provides convenient transportation for families and larger pilgrimage groups."
    },
    {
        title: "Chavadi",
        description:
            "Chavadi is a historically significant location in Shirdi connected with Sai Baba's life and devotional traditions. It is located close to the main temple area and is commonly included in Shirdi sightseeing and pilgrimage itineraries. Group travelers from Pune can conveniently visit Chavadi along with other important places using one chauffeur-driven Tempo Traveller, making the local movement easier and more organized."
    },
    {
        title: "Gurusthan",
        description:
            "Gurusthan is regarded as an important spiritual location in Shirdi and is traditionally associated with Sai Baba's early presence in the town. Devotees visiting Shirdi often include this peaceful site in their pilgrimage schedule along with the temple, Dwarkamai, and Chavadi. Traveling by Tempo Traveller allows families and groups to maintain a common itinerary and comfortably visit multiple spiritual locations during their Shirdi trip."
    },
    {
        title: "Khandoba Temple",
        description:
            "Khandoba Temple is another notable religious attraction associated with the early history of Sai Baba's arrival in Shirdi. The temple has cultural and spiritual importance and is often visited by devotees exploring the heritage of Shirdi. A Pune to Shirdi Tempo Traveller makes it easier for pilgrimage groups to include this location in their schedule while keeping all passengers together throughout the journey."
    },
    {
        title: "Shani Shingnapur",
        description:
            "Shani Shingnapur is a famous pilgrimage destination in Maharashtra known for the revered Shani temple and its unique religious traditions. Many travelers combine Shirdi Darshan with a visit to Shani Shingnapur as part of a wider pilgrimage itinerary. A Tempo Traveller provides a practical option for families and groups planning this combined journey from Pune, offering comfortable transportation and flexibility for sightseeing and return travel."
    },
    {
        title: "Sai Tirth Devotional Theme Park",
        description:
            "Sai Tirth Devotional Theme Park offers visitors an engaging way to experience stories and devotional themes connected with Sai Baba and Indian spiritual traditions. It can be included as an additional attraction during a Shirdi family trip or group tour. With a chauffeur-driven Tempo Traveller, larger groups can conveniently coordinate visits to the temple and other attractions while maintaining a comfortable sightseeing schedule."
    },
    {
        title: "Lendi Baug",
        description:
            "Lendi Baug is a peaceful garden in Shirdi with strong connections to Sai Baba's daily routine and devotional history. The garden provides visitors with a calm environment for reflection and is generally included in local Shirdi sightseeing plans. Families and pilgrimage groups traveling from Pune can use a Tempo Traveller to comfortably move between Lendi Baug, the temple complex, and other nearby spiritual attractions."
    },
    {
        title: "Wet N Joy Water Park",
        description:
            "Wet N Joy Water Park is a popular recreational attraction in Shirdi that can be considered by families looking to add leisure activities to their pilgrimage itinerary. It provides a different experience from the town's religious attractions and can be included when the travel schedule allows. A spacious Tempo Traveller makes group movement convenient, particularly for families carrying extra belongings and traveling with children."
    },
    {
        title: "Shirdi Local Market",
        description:
            "The local market around Shirdi provides devotees with opportunities to purchase religious souvenirs, Sai Baba photographs, devotional items, traditional products, snacks, and gifts for family members. It is a convenient addition to a Shirdi trip after completing Darshan and sightseeing. Groups traveling by Tempo Traveller can coordinate market visits according to their schedule before beginning their return journey to Pune."
    }
],

services: [
    {
        name: "Pune to Shirdi Tempo Traveller Hire",
        description: "Ruturaj Enterprises provides Pune to Shirdi Tempo Traveller Hire services for devotees, families, friends, and organized pilgrimage groups. Customers can select a suitable vehicle according to passenger count, luggage requirements, journey duration, and preferred comfort level. Professional chauffeurs, spacious seating, convenient Pune pickup, and flexible travel schedules make the journey to Shirdi more comfortable and organized."
    },
    {
        name: "Pune to Shirdi Tempo Traveller Booking",
        description: "Pune to Shirdi Tempo Traveller Booking with Ruturaj Enterprises offers a convenient way to arrange group transportation for Sai Baba Darshan, Shirdi Yatra, family trips, and group tours. Customers can provide their travel date, pickup location, number of passengers, and preferred vehicle type to plan the journey in advance. Flexible one-way and round-trip arrangements are available according to the travel itinerary."
    },
    {
        name: "AC Tempo Traveller Pune to Shirdi",
        description: "AC Tempo Traveller Pune to Shirdi is an excellent option for passengers who want comfortable group transportation during the journey. Ruturaj Enterprises provides spacious air-conditioned vehicles suitable for families, devotees, senior citizens, and larger groups. Comfortable seating, luggage space, professional chauffeur support, and planned pickup and drop arrangements help make the long-distance pilgrimage journey convenient."
    },
    {
        name: "Luxury Tempo Traveller Pune to Shirdi",
        description: "Luxury Tempo Traveller Pune to Shirdi provides an enhanced group travel experience for families and travelers who prefer additional comfort during their pilgrimage. Ruturaj Enterprises offers premium vehicle options with spacious interiors and comfortable seating for suitable group sizes. The service can be arranged for Shirdi Darshan, family tours, special occasions, and customized pilgrimage itineraries."
    },
    {
        name: "13 Seater Tempo Traveller Pune to Shirdi",
        description: "13 Seater Tempo Traveller Pune to Shirdi is suitable for smaller families, friends, and pilgrimage groups that want to travel together in one vehicle. Ruturaj Enterprises provides a practical transportation option with comfortable seating and adequate luggage space for the journey. The vehicle can be booked for one-way travel, return trips, Shirdi Darshan, or a customized pilgrimage schedule."
    },
    {
        name: "17 Seater Tempo Traveller Pune to Shirdi",
        description: "17 Seater Tempo Traveller Pune to Shirdi is designed for medium-sized groups traveling together for Sai Baba Darshan, family pilgrimage, or group tours. Instead of arranging several cars, passengers can stay together in one spacious vehicle and coordinate their itinerary more easily. Ruturaj Enterprises provides professional chauffeur support and flexible booking options according to the group's travel plans."
    },
    {
        name: "20 Seater Tempo Traveller Pune to Shirdi",
        description: "20 Seater Tempo Traveller Pune to Shirdi is a practical solution for larger families, tour groups, religious organizations, and friends traveling together. The larger seating capacity helps accommodate more passengers in one vehicle while simplifying pickup, travel, sightseeing, and return arrangements. Ruturaj Enterprises can organize the journey according to passenger requirements, luggage, travel dates, and preferred itinerary."
    },
    {
        name: "Tempo Traveller for Shirdi Darshan from Pune",
        description: "Tempo Traveller for Shirdi Darshan from Pune provides convenient group transportation for devotees planning a visit to Sai Baba Temple and other important spiritual locations. Ruturaj Enterprises supports families and groups with spacious vehicles, experienced chauffeurs, comfortable seating, and flexible travel plans. The itinerary can include temple Darshan, Dwarkamai, Chavadi, Gurusthan, Lendi Baug, and other nearby attractions."
    },
    {
        name: "Pune to Shirdi Tempo Traveller Rental",
        description: "Pune to Shirdi Tempo Traveller Rental from Ruturaj Enterprises offers flexible vehicle rental solutions for pilgrimage groups, family trips, and organized tours. Customers can choose a suitable seating configuration based on the size of their group and travel requirements. Chauffeur-driven transportation, convenient pickup points, luggage space, and flexible one-way or return options make the rental suitable for different Shirdi travel plans."
    },
    {
        name: "Pune to Shirdi Group Travel Tempo Traveller",
        description: "Pune to Shirdi Group Travel Tempo Traveller allows friends, relatives, devotees, and tour groups to complete their journey together instead of splitting passengers between different vehicles. Ruturaj Enterprises provides spacious transportation that simplifies group coordination and allows passengers to follow a common travel schedule. The service is suitable for temple visits, pilgrimage tours, family functions, and group excursions."
    },
    {
        name: "Pune to Shirdi Family Trip Tempo Traveller",
        description: "Pune to Shirdi Family Trip Tempo Traveller is ideal for families traveling with children, senior citizens, and multiple pieces of luggage. Ruturaj Enterprises provides comfortable group transportation that allows the entire family to remain together throughout the journey. Flexible pickup, sightseeing, Darshan, meal stops, and return arrangements can be coordinated according to the family's preferred schedule."
    },
    {
        name: "Pune to Shirdi Round Trip Tempo Traveller",
        description: "Pune to Shirdi Round Trip Tempo Traveller provides convenient transportation for families and groups planning to travel from Pune to Shirdi and return after Darshan or sightseeing. Ruturaj Enterprises can coordinate the departure and return schedule according to the group's itinerary, helping passengers avoid the need to arrange separate transportation for the return journey."
    },
    {
        name: "Pune to Shirdi One Way Tempo Traveller",
        description: "Pune to Shirdi One Way Tempo Traveller is suitable for passengers who need a comfortable group transfer from Pune to Shirdi without booking a return journey. Ruturaj Enterprises provides suitable vehicles for families, devotees, tour groups, and travelers with onward travel arrangements. Professional chauffeur support and convenient pickup planning help make the one-way journey smooth and hassle-free."
    },
    {
        name: "Affordable Tempo Traveller Pune to Shirdi",
        description: "Affordable Tempo Traveller Pune to Shirdi provides a cost-effective option for groups that want to travel together without hiring multiple cars. Ruturaj Enterprises offers vehicle choices based on passenger count and travel requirements, helping groups select a practical option for their budget. The service is suitable for family pilgrimages, Sai Baba Darshan, group tours, and one-day or return travel plans."
    },
    {
        name: "Tempo Traveller Hire for Shirdi Yatra Pune",
        description: "Tempo Traveller Hire for Shirdi Yatra Pune is designed for devotees and families planning a dedicated pilgrimage to Shirdi. Ruturaj Enterprises provides chauffeur-driven vehicles suitable for group travel, allowing passengers to follow a coordinated itinerary covering Darshan and nearby religious attractions. Comfortable seating, luggage space, and flexible scheduling make the service suitable for traditional family and group Yatra plans."
    },
    {
        name: "Tempo Traveller for Shirdi Tour Pune",
        description: "Tempo Traveller for Shirdi Tour Pune provides group transportation for travelers who want to combine Sai Baba Darshan with local sightseeing and nearby pilgrimage destinations. Ruturaj Enterprises can arrange suitable vehicles for families, friends, and organized groups while allowing flexibility in the sightseeing schedule. The tour can be customized according to travel duration, passenger strength, and selected destinations."
    },
    {
        name: "Pune to Shirdi AC Traveller Rental",
        description: "Pune to Shirdi AC Traveller Rental offers comfortable air-conditioned group transportation for devotees and travelers making the journey from Pune. Ruturaj Enterprises provides spacious vehicles for suitable group sizes with professional chauffeur assistance and convenient pickup arrangements. AC travel is particularly useful for families, senior citizens, and passengers seeking a more comfortable experience during the highway journey."
    },
    {
        name: "Pune Shirdi Outstation Tempo Traveller",
        description: "Pune Shirdi Outstation Tempo Traveller provides dependable group transportation for passengers traveling beyond Pune for pilgrimage and family purposes. Ruturaj Enterprises supports one-way, round-trip, and customized travel plans with suitable Tempo Traveller options. Groups can coordinate pickup locations, Darshan schedules, sightseeing stops, and return arrangements according to their planned Shirdi itinerary."
    },
    {
        name: "Tempo Traveller for Sai Baba Darshan Pune",
        description: "Tempo Traveller for Sai Baba Darshan Pune offers a convenient group travel solution for devotees visiting Shirdi from Pune. Ruturaj Enterprises provides comfortable vehicles for families, friends, and religious groups, allowing everyone to travel together and coordinate the Darshan schedule. The service can include convenient pickup, direct travel to Shirdi, local temple-area transportation, and return arrangements."
    },
    {
        name: "Tempo Traveller Booking for Shirdi Yatra",
        description: "Tempo Traveller Booking for Shirdi Yatra helps families and pilgrimage groups organize their transportation before traveling to Shirdi. Ruturaj Enterprises provides vehicle options according to group size, travel date, luggage requirements, and preferred comfort level. Advance planning allows the group to coordinate departure timing, Darshan, local sightseeing, and the return journey more conveniently."
    },
    {
        name: "Pune to Shirdi Traveller for Family",
        description: "Pune to Shirdi Traveller for Family provides comfortable transportation for families visiting Sai Baba Temple and nearby attractions. Ruturaj Enterprises offers spacious chauffeur-driven vehicles that can accommodate family members and luggage together. The travel plan can be arranged around children's needs, senior citizens, Darshan timings, meal breaks, sightseeing, and return schedules."
    },
    {
        name: "Pune to Shirdi Traveller for Group Tour",
        description: "Pune to Shirdi Traveller for Group Tour is suitable for friends, relatives, devotional groups, community organizations, and tour parties traveling together. Ruturaj Enterprises provides appropriate Tempo Traveller options based on group size and itinerary. Traveling in one vehicle makes coordination easier and allows the complete group to follow a common schedule throughout the Pune to Shirdi journey."
    }
],

tableData: [
    ["Pune to Shirdi Tempo Traveller Hire", "Pune to Shirdi Tempo Traveller Booking"],
    ["AC Tempo Traveller Pune to Shirdi", "Luxury Tempo Traveller Pune to Shirdi"],
    ["13 Seater Tempo Traveller Pune to Shirdi", "17 Seater Tempo Traveller Pune to Shirdi"],
    ["20 Seater Tempo Traveller Pune to Shirdi", "Tempo Traveller for Shirdi Darshan from Pune"],
    ["Pune to Shirdi Tempo Traveller Rental", "Pune to Shirdi Group Travel Tempo Traveller"],
    ["Pune to Shirdi Family Trip Tempo Traveller", "Pune to Shirdi Round Trip Tempo Traveller"],
    ["Pune to Shirdi One Way Tempo Traveller", "Affordable Tempo Traveller Pune to Shirdi"],
    ["Tempo Traveller Hire for Shirdi Yatra Pune", "Tempo Traveller for Shirdi Tour Pune"],
    ["Pune to Shirdi AC Traveller Rental", "Pune Shirdi Outstation Tempo Traveller"],
    ["Tempo Traveller for Sai Baba Darshan Pune", "Tempo Traveller Booking for Shirdi Yatra"],
    ["Pune to Shirdi Traveller for Family", "Pune to Shirdi Traveller for Group Tour"]
],

whychoose: [
    {
        WhyChooseheading: "Dedicated Group Travel for Shirdi Pilgrimage",
        WhyChoosedescription: "Ruturaj Enterprises provides convenient Tempo Traveller transportation for devotees traveling from Pune to Shirdi. Families, friends, and pilgrimage groups can stay together in one vehicle while managing their Darshan schedule, luggage, sightseeing, and return journey more comfortably."
    },
    {
        WhyChooseheading: "Multiple Seating Capacity Options",
        WhyChoosedescription: "Different group sizes can select an appropriate vehicle according to their passenger requirements. Options such as 13 Seater, 17 Seater, and 20 Seater Tempo Travellers make it easier for families and larger pilgrimage groups to avoid booking multiple cars."
    },
    {
        WhyChooseheading: "Comfortable AC Travel from Pune",
        WhyChoosedescription: "Passengers looking for a more comfortable highway journey can choose an AC Tempo Traveller for their Shirdi trip. Spacious seating and professional chauffeur support help families, devotees, and senior citizens enjoy a more convenient travel experience."
    },
    {
        WhyChooseheading: "Suitable for Sai Baba Darshan and Yatra",
        WhyChoosedescription: "The service is planned around the requirements of Shirdi pilgrims, making it suitable for Sai Baba Darshan, Shirdi Yatra, temple visits, and nearby spiritual sightseeing. Groups can coordinate their departure and return timings according to their planned pilgrimage schedule."
    },
    {
        WhyChooseheading: "Convenient One-Way and Round-Trip Plans",
        WhyChoosedescription: "Travelers can choose a one-way Tempo Traveller when they have onward arrangements or select a round-trip package when they want the same vehicle for their return to Pune. This flexibility makes the service suitable for different pilgrimage and family travel plans."
    },
    {
        WhyChooseheading: "Comfortable Choice for Families",
        WhyChoosedescription: "Families traveling with children, elderly members, and luggage can benefit from the additional space of a Tempo Traveller. Everyone can remain together during the journey, while pickup, sightseeing, Darshan, meal stops, and return travel can be coordinated around the family's requirements."
    },
    {
        WhyChooseheading: "Useful for Group Tours and Religious Trips",
        WhyChoosedescription: "Friends, relatives, devotional groups, and organized tour parties can use Tempo Travellers for Shirdi group tours. One shared vehicle simplifies communication and coordination while allowing the group to follow a common itinerary throughout the trip."
    },
    {
        WhyChooseheading: "Flexible Shirdi Sightseeing Itineraries",
        WhyChoosedescription: "A Shirdi trip can include more than the main temple, with attractions such as Dwarkamai, Chavadi, Gurusthan, Lendi Baug, Khandoba Temple, and nearby pilgrimage destinations. Ruturaj Enterprises supports flexible travel planning so groups can include suitable stops in their itinerary."
    }
]


};


const faqData = [
{
question: "Why is a Tempo Traveller a good choice for a Pune to Shirdi trip?",
answer: "A Tempo Traveller is well suited for group travel between Pune and Shirdi because passengers can stay together in one spacious vehicle. Ruturaj Enterprises offers a convenient option for families, friends, religious groups, and organized tours traveling to Shirdi."
},
{
question: "Can I hire a Tempo Traveller from Pune to Shirdi for a family pilgrimage?",
answer: "Family groups can choose a Tempo Traveller for their Shirdi pilgrimage when they want comfortable group transportation with convenient seating and luggage space. The arrangement is useful for families traveling together for darshan and related religious visits."
},
{
question: "What type of groups can book a Pune to Shirdi Tempo Traveller?",
answer: "Ruturaj Enterprises can arrange Tempo Traveller rentals for families, friends, senior citizen groups, corporate teams, religious groups, and tour parties traveling from Pune to Shirdi for pilgrimages, sightseeing, or special occasions."
},
{
question: "Is a Tempo Traveller suitable for a one-day Pune to Shirdi trip?",
answer: "A one-day journey can be planned with a Tempo Traveller when the group wants to travel from Pune to Shirdi, complete their visit, and return according to a planned schedule. The spacious vehicle makes the arrangement practical for group transportation."
},
{
question: "Can I book a Tempo Traveller from Pune to Shirdi for multiple people?",
answer: "Yes, group travelers can select a suitable Tempo Traveller according to their passenger count and travel requirements. Traveling together in one vehicle can make coordination easier compared with arranging several separate cars."
},
{
question: "Does Ruturaj Enterprises provide driver-assisted Tempo Traveller service to Shirdi?",
answer: "Driver-assisted travel can be arranged by Ruturaj Enterprises for the Pune to Shirdi route, allowing passengers to focus on their pilgrimage and group activities while the driver manages the road journey."
},
{
question: "Can we carry luggage in a Pune to Shirdi Tempo Traveller?",
answer: "Tempo Travellers provide useful luggage capacity for group journeys, allowing passengers to carry personal bags and necessary belongings. The available space depends on the selected vehicle and number of travelers."
},
{
question: "Can senior citizens travel comfortably in a Tempo Traveller to Shirdi?",
answer: "For families traveling with elderly members, a spacious group vehicle can make the journey more convenient by keeping everyone together and reducing the need to coordinate multiple cars throughout the Pune to Shirdi trip."
},
{
question: "Can I include other places along with Shirdi during the trip?",
answer: "A customized itinerary can be discussed with Ruturaj Enterprises if the group wants to combine Shirdi with nearby destinations or additional religious and sightseeing locations. The route can be planned according to the group's schedule."
},
{
question: "How can I book a Pune to Shirdi Tempo Traveller with Ruturaj Enterprises?",
answer: "To arrange your Pune to Shirdi Tempo Traveller, provide Ruturaj Enterprises with your travel date, pickup location, passenger count, trip duration, and preferred vehicle requirements. The rental option can then be planned according to your group travel needs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Sandeep Kulkarni",
feedback:
"Our family booked a Tempo Traveller from Pune to Shirdi through Ruturaj Enterprises for a pilgrimage trip. The vehicle was spacious and comfortable for everyone, and having the entire family together made the journey much easier and more enjoyable.",
rating: 5
},
{
id: 2,
name: "Miss. Anjali Patil",
feedback:
"Ruturaj Enterprises arranged a Tempo Traveller for our group visit to Shirdi, and the experience was very smooth. There was enough room for our group and luggage, while the driver handled the journey professionally. We were happy with the overall service.",
rating: 5
}
];









    const Images = [
        { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
        { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller on Rent", link: "Pune-to-Shirdi-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "Pune-to-Mahabaleshwar-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller", link: "Pune-to-Goa-Tempo-Traveller" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "Pune-to-Mumbai-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/6.jpg", text: "Pune to Konkan Tempo Traveller", link: "Pune-to-Konkan-Tempo-Traveller" },
        { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "Pune-to-Nashik-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller On Rent", link: "Pune-Darshan-Tempo-Traveller-On-Rent" },
        { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller on Rent", link: "13-Seater-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/12.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller on Rent in Pune", link: "26-Seater-Tempo-Traveller-on-Rent-in-Pune" },
        { place: "/images/keyword/14.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
        { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/16.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
        { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/18.jpg", text: "Bus Rentals For School Trips in Pune", link: "Bus-Rentals-For-School-Trips-in-Pune" },
        { place: "/images/keyword/19.jpg", text: "Bus booking for wedding in Pune", link: "Bus-booking-for-wedding-in-Pune" },
        { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage", link: "Bus-Booking-for-Marriage" },
        { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate Pune", link: "Bus-Service-for-Corporate-Pune" },
        { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "Bus-on-Rent-For-Event-in-Pune" },
        { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation", link: "Bus-Hire-for-Outstation" },
        { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "AC-Bus-On-Rent-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "Pune-Bus-Hire-Rental-Service" },
    ];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Shirdi Tempo Traveller on Rent",
  "image": "https://ruturajenterprises.com/assets/images/pune-to-shirdi-tempo-traveller-on-rent.webp",
  "description":
    "Pune to Shirdi Tempo Traveller on Rent from Ruturaj Enterprises is a comfortable group travel option for families, friends, senior citizens, corporate groups, pilgrims and tour groups planning a convenient journey from Pune to Shirdi. Pune to Shirdi Tempo Traveller Hire is suitable for one-way transfers, round trips, same-day darshan journeys, weekend travel and multi-day religious tours. Pune to Shirdi Tempo Traveller Booking can be arranged according to group size, travel schedule, pickup location and return requirements, with professional driver assistance for a smoother road journey. AC Tempo Traveller Pune to Shirdi provides a comfortable environment for the approximately 185 to 200 km road journey, making it suitable for families and groups traveling together. Luxury Tempo Traveller Pune to Shirdi is a suitable choice for travelers looking for a more premium and comfortable group transportation experience. 13 Seater Tempo Traveller Pune to Shirdi and 17 Seater Tempo Traveller Pune to Shirdi can accommodate different group sizes while allowing passengers to travel together in one vehicle. The route is commonly used for Shirdi pilgrimage trips, Sai Baba darshan, family religious tours, temple visits, corporate spiritual outings and organized group journeys. Pickup can be arranged from areas such as Shivajinagar, Swargate, Kothrud, Baner, Aundh, Wakad, Hinjewadi, Pimpri, Chinchwad, Viman Nagar, Kharadi, Hadapsar, Kondhwa, Katraj, Talegaon, Moshi and other Pune locations. Travelers can plan direct Pune to Shirdi transfers or include nearby pilgrimage destinations and attractions such as Shani Shingnapur, Nashik, Trimbakeshwar and other religious places depending on the itinerary. For return travel, Pune to Shirdi Tempo Traveller Round Trip service allows the same group to complete darshan and sightseeing before returning to Pune. The vehicle can also be arranged for family functions, group tours, senior citizen pilgrimage trips, weekend religious travel and customized Maharashtra temple circuits. Ruturaj Enterprises focuses on convenient group transportation with experienced drivers and flexible rental arrangements for Pune to Shirdi journeys.",
  "brand": {
    "@type": "Brand",
    "name": "Ruturaj Enterprises"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://ruturajenterprises.com/pune-to-shirdi-tempo-traveller-on-rent"
  }
};



    return (
        <div>

<Helmet>
  <title>Pune to Shirdi Tempo Traveller on Rent | Pune to Shirdi Tempo Traveller Hire | +91 9763381382</title>

  <meta
    name="description"
    content="Pune to Shirdi Tempo Traveller on Rent for Sai Baba darshan, family pilgrimage, group tours and religious trips. Hire 13 and 17 seater AC and Luxury Tempo Travellers with professional driver assistance."
  />

  <meta
    name="keywords"
    content="Pune to Shirdi Tempo Traveller Hire, Pune to Shirdi Tempo Traveller Booking, AC Tempo Traveller Pune to Shirdi, Luxury Tempo Traveller Pune to Shirdi, 13 Seater Tempo Traveller Pune to Shirdi, 17 Seater Tempo Traveller Pune to Shirdi, Pune to Shirdi Tempo Traveller on Rent, Pune to Shirdi Tempo Traveller Rental, Pune to Shirdi Tempo Traveller Service, Pune to Shirdi Tempo Traveller with Driver, Pune to Shirdi Traveller Hire, Pune to Shirdi Traveller Booking, Pune to Shirdi Traveller Rental, Pune to Shirdi AC Traveller, Pune to Shirdi Luxury Traveller, Pune to Shirdi 13 Seater Traveller, Pune to Shirdi 17 Seater Traveller, Pune to Shirdi Tempo Traveller One Way, Pune to Shirdi Tempo Traveller Round Trip, Pune to Shirdi Tempo Traveller Same Day, Pune to Shirdi Tempo Traveller for Darshan, Pune to Shirdi Tempo Traveller for Pilgrimage, Pune to Shirdi Tempo Traveller for Family Trip, Pune to Shirdi Tempo Traveller for Group Travel, Pune to Shirdi Tempo Traveller for Senior Citizens, Pune to Shirdi Tempo Traveller for Religious Tour, Pune to Shirdi Tempo Traveller for Temple Tour, Pune to Shirdi Tempo Traveller for Sai Baba Darshan, Pune to Shirdi Tempo Traveller for Weekend Trip, Pune to Shirdi Tempo Traveller for Corporate Group, Pune to Shirdi Tempo Traveller for Tourist Group, Pune to Shirdi Tempo Traveller for Friends Trip, Pune to Shirdi Tempo Traveller for Family Tour, Pune to Shirdi Tempo Traveller for Pilgrimage Tour, Pune to Shirdi Tempo Traveller for Religious Trip, Pune to Shirdi Tempo Traveller Rental with Driver, Pune to Shirdi Tempo Traveller Hire with Driver, Pune to Shirdi Tempo Traveller Booking with Driver, Pune to Shirdi Tempo Traveller Affordable Rental, Affordable Tempo Traveller Pune to Shirdi, Budget Tempo Traveller Pune to Shirdi, Comfortable Tempo Traveller Pune to Shirdi, Premium Tempo Traveller Pune to Shirdi, Pune to Shirdi Tempo Traveller Full Day, Pune to Shirdi Tempo Traveller Multi Day, Pune to Shirdi Tempo Traveller Weekend Rental, Pune to Shirdi Tempo Traveller Outstation, Pune to Shirdi Outstation Tempo Traveller, Pune to Shirdi Tempo Traveller Tour Package, Pune to Shirdi Tempo Traveller Sightseeing, Pune to Shirdi and Shani Shingnapur Tempo Traveller, Pune to Shirdi and Nashik Tempo Traveller, Pune to Shirdi and Trimbakeshwar Tempo Traveller, Pune to Shirdi Religious Tour Package, Pune to Shirdi Pilgrimage Tour Package, Pune to Shirdi Family Tour Package, Pune to Shirdi Group Tour Package, Pune to Shirdi Sai Baba Tour, Pune to Shirdi Darshan Trip, Pune to Shirdi Temple Tour, Pune to Shirdi Road Trip, Pune to Shirdi Travel Service, Pune to Shirdi Group Transportation, Pune to Shirdi Family Transportation, Pune to Shirdi Tourist Transportation, Pune to Shirdi Pilgrimage Transportation, Pune to Shirdi Religious Transportation, Pune to Shirdi Private Traveller, Pune to Shirdi Private Tempo Traveller, Pune to Shirdi Tempo Traveller Near Me, Tempo Traveller Pune to Shirdi from Kothrud, Tempo Traveller Pune to Shirdi from Baner, Tempo Traveller Pune to Shirdi from Aundh, Tempo Traveller Pune to Shirdi from Wakad, Tempo Traveller Pune to Shirdi from Hinjewadi, Tempo Traveller Pune to Shirdi from Pimpri, Tempo Traveller Pune to Shirdi from Chinchwad, Tempo Traveller Pune to Shirdi from Viman Nagar, Tempo Traveller Pune to Shirdi from Kharadi, Tempo Traveller Pune to Shirdi from Hadapsar, Tempo Traveller Pune to Shirdi from Kondhwa, Tempo Traveller Pune to Shirdi from Katraj, Tempo Traveller Pune to Shirdi from Shivajinagar, Tempo Traveller Pune to Shirdi from Swargate, Tempo Traveller Pune to Shirdi from Talegaon, Tempo Traveller Pune to Shirdi from Moshi, Tempo Traveller Pune to Shirdi from Bhosari, Pune to Shirdi 13 Seater Tempo Traveller Rental, Pune to Shirdi 17 Seater Tempo Traveller Rental, Pune to Shirdi 13 Seater Tempo Traveller Hire, Pune to Shirdi 17 Seater Tempo Traveller Hire, Pune to Shirdi 13 Seater Tempo Traveller Booking, Pune to Shirdi 17 Seater Tempo Traveller Booking, Pune to Shirdi AC 13 Seater Tempo Traveller, Pune to Shirdi AC 17 Seater Tempo Traveller, Pune to Shirdi Luxury 13 Seater Tempo Traveller, Pune to Shirdi Luxury 17 Seater Tempo Traveller, Pune to Shirdi Tempo Traveller for Sai Baba Temple, Pune to Shirdi Tempo Traveller for Shani Shingnapur, Pune to Shirdi Tempo Traveller for Nashik Tour, Pune to Shirdi Tempo Traveller for Trimbakeshwar Tour"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="ltn__breadcrumb-area ltn__breadcrumb-area-2 ltn__breadcrumb-color-white bg-overlay-theme-black-90 bg-image"
                style={{ backgroundImage: "url('/img/bg/9.jpg')" }}
            >
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="ltn__breadcrumb-inner ltn__breadcrumb-inner-2 justify-content-between">
                                <div className="section-title-area ltn__section-title-2">
                                    <h1 className="section-title white-color">
                                        {cardData.keyword}
                                    </h1>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>






















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/2.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Ruturaj Enterprises: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">

                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable /> */}

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Ruturaj Enterprises</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Ruturaj Enterprises </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                {/* <FleetHighway /> */}
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919763381382" className="pc-call">+91 9763381382</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919011051114" className="pc-call">+91 9011051114</a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919822697554" className="pc-call">+91 9822697554</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919763381382"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919763381382" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@ruturajenterprises.com" className="pc-email">
                                            booking@ruturajenterprises.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Ruturaj Enterprises</strong><br />

                                            Nandini Takle Nagar, Pune - Solapur Road Manjri Bk Hadapsar, Pune, Maharashtra 412307
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetoshirditempo;